import React from "react";
import Layout from "../../../../Layout";
import HeaderReports from "../../../HeaderReports";
import ListUserAccountHistory from "./ListUserAccountHistory";
import UserAccountHistorySearch from "./UserAccountHistorySearch";
import useUserStore from "../../../../../utils/storeApp";

const UserAccountHistory = () => {
  const { isUserLogedIn, userRole, userToken } = useUserStore((state) => ({
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    userToken: state.userToken,
  }));

  return (
    <Layout>
      {userRole === "SES ADMINISTRATOR" ||
      userRole === "ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR" ? (
        <HeaderReports />
      ) : null}
      <ListUserAccountHistory />
      <UserAccountHistorySearch />
    </Layout>
  );
};

export default UserAccountHistory;
